import { useState } from 'react';
import { ViewResolver } from '@Components/ViewResolver';

import { VendorPopupTab } from './VendorPopupTab.enum';
import VendorPopupDesktop from './desktop/VendorPopupDesktop';
import VendorPopupMobile from './mobile/VendorPopupMobile';

export interface VendorPopupProps {
  isOpened: boolean;
  vendorId: number;
  title: string;
  onClose: () => void;
}

const VendorPopup: React.FC<VendorPopupProps> = ({
  isOpened,
  vendorId,
  onClose,
  title,
}) => {
  const [tab, setTab] = useState<VendorPopupTab>(VendorPopupTab.Remarks);

  const handleTabChange = (selectedTab: VendorPopupTab): void => {
    setTab(selectedTab);
  };

  return (
    <ViewResolver
      desktop={
        <VendorPopupDesktop
          isOpened={isOpened}
          onClose={onClose}
          tab={tab}
          onTabChange={handleTabChange}
          title={title}
          vendorId={vendorId}
        />
      }
      mobile={
        <VendorPopupMobile
          isOpened={isOpened}
          onClose={onClose}
          tab={tab}
          onTabChange={handleTabChange}
          title={title}
          vendorId={vendorId}
        />
      }
    />
  );
};

export default VendorPopup;
